import React from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { FileDown, ShieldCheck } from "lucide-react";
import { useApp } from "@/context/AppContext";

export default function NDNCASignedCard({ meta, onDownload }) {
  const { lang } = useApp();
  const copyHash = () => {
    navigator.clipboard.writeText(meta.pdf_sha256);
    toast.success(lang === "it" ? "Hash copiato" : "Hash copied");
  };
  return (
    <div className="rounded-md border border-emerald-600/40 bg-emerald-50 p-4 space-y-3" data-testid="ndnca-signed-card">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <ShieldCheck className="h-5 w-5 text-emerald-700" />
          <p className="text-sm text-emerald-800 font-medium">
            {lang === "it" ? "NDNCA firmato con OTP" : "NDNCA signed via OTP"}
          </p>
        </div>
        <Button
          onClick={onDownload}
          data-testid="ndnca-download-pdf"
          className="bg-emerald-700 text-white hover:bg-emerald-800 rounded-full"
        >
          <FileDown className="h-4 w-4 me-2" /> PDF
        </Button>
      </div>
      <div className="border-t border-emerald-200 pt-3 space-y-1">
        <p className="text-[10px] tracking-widest uppercase text-emerald-800">
          {lang === "it" ? "Prova di integrità" : "Integrity proof"}
        </p>
        <p className="text-[11px] text-emerald-900">
          <span className="text-emerald-700">ID:</span> <span className="font-mono">{meta.id}</span>
        </p>
        <p className="text-[11px] text-emerald-900 break-all">
          <span className="text-emerald-700">SHA-256:</span> <span className="font-mono">{meta.pdf_sha256}</span>
        </p>
        <p className="text-[11px] text-emerald-900">
          <span className="text-emerald-700">{lang === "it" ? "Firmato il" : "Signed on"}:</span>{" "}
          <span className="font-mono">{new Date(meta.signed_at).toLocaleString()}</span>
        </p>
        <button
          data-testid="ndnca-copy-hash"
          onClick={copyHash}
          className="mt-1 text-[11px] text-emerald-700 hover:text-emerald-900 underline"
        >
          {lang === "it" ? "Copia hash" : "Copy hash"}
        </button>
      </div>
    </div>
  );
}
